/* global jQuery */

import classNames from "classnames";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";

import { getRelativeDateString } from "app/lib/date";
import { jobTime } from "app/lib/jobs";
import { track } from "app/lib/segmentAnalytics";
import BuildPageStore from "app/stores/BuildPageStore";
import Button from "app/components/shared/Button";
import Dialog from "app/components/shared/Dialog";
import Duration from "app/components/shared/Duration";
import Icon from "app/components/shared/Icon";
import JobActivityTimeline from "app/components/JobActivityTimeline";
import LegacyDispatcher from "app/lib/legacyDispatcher";
import parseEmoji from "app/lib/parseEmoji";
import PipelineStateIcon from "app/components/shared/PipelineStateIcon";
import RemoteButtonComponent from "app/components/shared/RemoteButtonComponent";
import UserAvatar from "app/components/shared/UserAvatar";

import Command from "./Command";
import JobArtifacts from "./Artifacts";
import JobArtifactsCount from "./ArtifactsCount";
import JobEnvironment from "./Environment";
import JobLog from "./Log";
import WaitTime from "./WaitTime";
import Agent from "./Agent";
import ClusterQueue from "./ClusterQueue";
import Signature from "./Signature";
import { MissingStepDependencies } from "app/components/job/Job/MissingStepDependencies";

export const elementIdFor = (jobId) => `job-${jobId}`;

const TERMINAL_JOB_STATES = ["finished", "timed_out", "canceled", "expired"];
const TERMINAL_BUILD_STATES = [
  "passed",
  "failed",
  "canceled",
  "skipped",
  "not_run",
];

/* eslint-disable react/prefer-es6-class */
// TODO: Move to a class

export default createReactClass({
  displayName: "Job",

  propTypes: {
    className: PropTypes.string,
    build: PropTypes.object.isRequired,
    buildStore: PropTypes.shape({
      loadAndEmit: PropTypes.func.isRequired,
    }).isRequired,
    job: PropTypes.shape({
      id: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      passed: PropTypes.bool.isRequired,
      softFailed: PropTypes.bool.isRequired,
      command: PropTypes.string.isRequired,
      name: PropTypes.string,
      basePath: PropTypes.string.isRequired,
      agentName: PropTypes.string,
      parallelGroupTotal: PropTypes.number,
      parallelGroupIndex: PropTypes.number,
      matrix: PropTypes.string,
      cancelable: PropTypes.shape({
        allowed: PropTypes.bool.isRequired,
      }),
      retryable: PropTypes.shape({
        allowed: PropTypes.bool.isRequired,
        message: PropTypes.string,
      }).isRequired,
      retriedInJobUuid: PropTypes.string,
      retriedBy: PropTypes.shape({
        name: PropTypes.string.isRequired,
        avatarUrl: PropTypes.string.isRequired,
      }),
      step: PropTypes.shape({
        signature: PropTypes.shape({
          value: PropTypes.string,
          algorithm: PropTypes.string,
          signedFields: PropTypes.arrayOf(PropTypes.string),
        }),
      }),
      createdAt: PropTypes.string,
      startedAt: PropTypes.string,
      agentAssignedAt: PropTypes.string,
      agentAcceptedAt: PropTypes.string,
      retriedAt: PropTypes.string,
      runnableAt: PropTypes.string,
      canceledAt: PropTypes.string,
      finishedAt: PropTypes.string,
      timedOutAt: PropTypes.string,
      expiredAt: PropTypes.string,
      agentsPath: PropTypes.string,
      hostedAgentSshPath: PropTypes.string,
      permissions: PropTypes.shape({
        retry: PropTypes.shape({
          allowed: PropTypes.bool.isRequired,
          message: PropTypes.string,
          reason: PropTypes.string,
        }).isRequired,
        cancel: PropTypes.shape({
          allowed: PropTypes.bool.isRequired,
          message: PropTypes.string,
          reason: PropTypes.string,
        }).isRequired,
      }).isRequired,
      testAnalytics: PropTypes.shape({
        runUrl: PropTypes.string,
      }).isRequired,
    }).isRequired,
  },

  tabs() {
    return [
      {
        id: "output",
        name: "Log",
        component: JobLog,
      },
      {
        id: "artifacts",
        name: "Artifacts",
        count: JobArtifactsCount,
        component: JobArtifacts,
      },
      {
        id: "timeline",
        name: "Timeline",
        component: JobActivityTimeline,
      },
      {
        id: "env",
        name: "Environment",
        component: JobEnvironment,
      },
    ].filter(Boolean);
  },

  notifyStoreOfRender() {
    if (this.state.expanded) {
      // Trigger the action in the next execution thread because there's a high
      // chance that this method was called as part of a dispatch and we don't
      // want to cause a loop
      setTimeout(
        () =>
          LegacyDispatcher.emit("job:expanded", {
            job: this.props.job,
            el: this.wrapperNode,
          }),
        0,
      );
    }
  },

  getInitialState() {
    return {
      tab: "output",
      expanded: this.suggestedExpandedState(),
      cancelJobDialogOpen: false,
    };
  },

  // Some magic to determine the default expanded state for the job.
  suggestedExpandedState() {
    return BuildPageStore.isJobExpanded(this.props.job);
  },

  componentDidMount() {
    BuildPageStore.addChangeListener(this.props.job, this._onStoreChange);
    this.notifyStoreOfRender();
  },

  componentWillUnmount() {
    BuildPageStore.removeChangeListener(this.props.job, this._onStoreChange);
  },

  componentDidUpdate() {
    this.notifyStoreOfRender();
  },

  _onStoreChange() {
    const expanded = BuildPageStore.isJobExpanded(this.props.job);

    // If we're changing from expanded to not exapnded, and the wrapping
    // element is outside the viewport (meaning the header is likely stickied
    // to the top of it), scroll to the top of the element so it stays in view
    // when it collapses. This is for Sticky Job Headers, but shouldn't change
    // much of note about the page's behaviour when that isn't enabled.
    if (
      this.state.expanded &&
      !expanded &&
      this.wrapperNode.offsetTop < window.scrollY
    ) {
      this.wrapperNode.scrollIntoView();
    }

    this.setState({ expanded });
  },

  scrollToAndExpandJob() {
    this.setState({ expanded: true }, () => {
      this.scrollToJob();
    });
  },

  scrollToJob() {
    const $anchor = jQuery(this.wrapperNode);
    jQuery(window).scrollTop($anchor.offset().top);
  },

  handleCancelJobClick() {
    this.setState({ cancelJobDialogOpen: true });
  },

  handleCancelJobDialogClose() {
    this.setState({ cancelJobDialogOpen: false });
  },

  handleTabClick(tab) {
    return (event) => {
      this.setState({ tab: tab.id });

      // If the browser viewport is below the top of the job component, scroll back to the top of the job component.
      if (this.wrapperNode.offsetTop < window.scrollY) {
        this.wrapperNode.scrollIntoView();
      }

      event.preventDefault();

      const startedAt = this.props.job.startedAt
        ? new Date(this.props.job.startedAt)
        : new Date();
      const timeSinceJobStarted = new Date() - startedAt;
      const daysSinceJobStarted = Math.floor(
        timeSinceJobStarted / 1000 / 60 / 60 / 24,
      );

      track("Job Tab Clicked", {
        tab_name: tab.name,
        job_id: this.props.job.id,
        job_state: this.props.job.state,
        days_since_job_started: daysSinceJobStarted,
      });
    };
  },

  handleClickHeader(evt) {
    window.location.href =
      window.location.pathname +
      `#${this.state.expanded ? "_" : this.props.job.id}`;

    // return if the user did a middle-click, right-click, or used a modifier
    // key (like ctrl-click, meta-click, shift-click, etc.)
    if (
      (evt.button && evt.button !== 0) ||
      evt.altKey ||
      evt.ctrlKey ||
      evt.metaKey ||
      evt.shiftKey
    ) {
      return;
    }

    LegacyDispatcher.emit("job:toggle", { job: this.props.job });
  },

  handleClickRetriedJobLink(evt) {
    // return if the user did a middle-click, right-click, or used a modifier
    // key (like ctrl-click, meta-click, shift-click, etc.)
    if (
      evt.button !== 0 ||
      evt.altKey ||
      evt.ctrlKey ||
      evt.metaKey ||
      evt.shiftKey
    ) {
      return;
    }

    LegacyDispatcher.emit("job:retried-link-click", { job: this.props.job });
  },

  tabMenuNodes() {
    return this.tabs().map((tab) => {
      let className = "btn btn-tab btn-tab--compact btn-tab--monochrome";

      if (this.state.tab === tab.id) {
        className += " btn-tab--active";
      }

      if (tab.count) {
        className += " btn-tab--badged";
      }

      return (
        <li key={tab.id} className="flex items-stretch">
          {this._renderTabLink(tab, className)}
        </li>
      );
    });
  },

  _renderTabLink(tab, className) {
    const TabCountComponent = tab.count;

    return (
      <button className={className} onClick={this.handleTabClick(tab)}>
        {tab.name}
        {TabCountComponent && <TabCountComponent job={this.props.job} />}
      </button>
    );
  },

  _renderNewBadge() {
    return (
      <span className="badge badge--outline ml1 tabular-numerals">New</span>
    );
  },

  tabContentNodes() {
    return this.tabs().map((tab) => {
      let className = "tab-pane";

      if (this.state.tab === tab.id) {
        className += " active";
        const contents = (
          <tab.component
            build={this.props.build}
            job={this.props.job}
            parentElementId={this.elementId()}
          />
        );
        return (
          <div key={tab.id} className={className}>
            {contents}
          </div>
        );
      }
    });
  },

  groupInfoNode() {
    let text = null;

    if (this.props.job.matrix) {
      text = "Matrix";
    } else if (
      this.props.job.parallelGroupTotal &&
      this.props.job.parallelGroupTotal > 1
    ) {
      text = `${this.props.job.parallelGroupIndex + 1}/${
        this.props.job.parallelGroupTotal
      }`;
    }

    if (text) {
      return (
        <div
          className="flex-none flex items-center small relative tabular-numerals px1 job-group-count"
          style={{ lineHeight: 1.75 }}
        >
          {text}
        </div>
      );
    }
  },

  commandNode() {
    if (this.props.job.command) {
      return (
        <Command
          command={this.props.job.command}
          onNestedLinkTrigger={this.handleNestedLinkTrigger}
        />
      );
    }
  },

  jobNameNode() {
    if (this.props.job.name) {
      return (
        <span
          onClick={
            window.Features.BuildsHighlightJobName
              ? this.handleClickNode
              : undefined
          }
          className="truncate job-name"
          style={{ flex: "0 0 auto" }}
          data-testid="JobName"
          dangerouslySetInnerHTML={{ __html: parseEmoji(this.props.job.name) }}
        />
      );
    }
  },

  signatureNode() {
    if (this.props.job.step.signature) {
      return (
        <Signature
          algorithm={this.props.job.step.signature.algorithm}
          onNestedLinkTrigger={this.handleNestedLinkTrigger}
        />
      );
    }
  },

  elementId() {
    return elementIdFor(this.props.job.id);
  },

  renderTestAnalyticsButton() {
    const { runUrl } = this.props.job.testAnalytics;
    // These flags are only set for authenticated users with TA
    const runLinkEnabled = Features.Analytics;

    // runUrl returns as null when the run suite is not public, the job doesn't have an
    // associated run, or if the associated run didn't have the job id sent in the run env
    if (
      runUrl &&
      (runLinkEnabled || !Features.AnalyticsPublicSuiteEmergencyStop)
    ) {
      return (
        <Button
          href={runUrl}
          style={{ fontSize: 13, height: 34, lineHeight: "13px" }}
        >
          View in Test Analytics
        </Button>
      );
    }
  },

  renderSSHButton() {
    const running = this.props.job.state === "running";
    const hostedAgentSSHPath = this.props.job.hostedAgentSshPath;

    if (running && hostedAgentSSHPath) {
      return (
        <Button
          href={hostedAgentSSHPath}
          style={{ fontSize: 13, height: 34, lineHeight: "13px" }}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center"
        >
          <i
            className="fa fa-terminal white bg-black bg-rounded small rounded mr1"
            style={{ padding: "2px 4px" }}
          />{" "}
          Open Terminal{" "}
          <i
            className="fa fa-external-link ml1 dark-gray small"
            style={{ position: "relative", top: "1px" }}
          />
        </Button>
      );
    }
  },

  renderRetryJobButton() {
    // Before attempting to render the button, we'll see if we've already
    // retried this job, and if we have, render who did it and when.
    let retryNotAllowedMessage;
    if (this.props.job.retriedInJobUuid) {
      const linkContents = this.props.job.retriedBy ? (
        <>
          <UserAvatar
            user={{
              name: this.props.job.retriedBy.name,
              avatar: { url: this.props.job.retriedBy.avatarUrl },
            }}
            className="mx1"
            style={{
              width: 20,
              height: 20,
            }}
            suppressAltText={true}
          />
          <span>
            <span className="semi-bold">{this.props.job.retriedBy.name}</span>
            &nbsp;retried {getRelativeDateString(this.props.job.retriedAt)}
          </span>
        </>
      ) : (
        <>
          <Icon
            icon="retry"
            className="flex-none"
            style={{
              width: 14,
              height: 14,
              position: "relative",
              top: -1,
              marginLeft: 3,
              marginRight: 3,
            }}
          />
          Automatically retried{" "}
          {getRelativeDateString(this.props.job.retriedAt)}
        </>
      );

      return (
        <a
          href={
            window.location.pathname + `#${this.props.job.retriedInJobUuid}`
          }
          onClick={this.handleClickRetriedJobLink}
          className="text-decoration-underline black hover-black flex items-center block py1 xs-hide"
          style={{ fontSize: 13 }}
        >
          {linkContents}
        </a>
      );
    }

    // We never want to show the retry button if the current user is anonymous,
    // so we'll just bail out early here and return nothing.
    if (this.props.job.permissions.retry.reason === "anonymous") {
      return null;
    }

    // Don't show the retry button if it's not finished.
    if (!TERMINAL_JOB_STATES.includes(this.props.job.state)) {
      return null;
    }

    // Also don't show the retry button if the job has "passed" and there isn't
    // an error message (we may want to show the retry button for failed jobs if
    // the user has configured it to be allowed)
    if (this.props.job.passed && !this.props.job.retryable.allowed) {
      return null;
    }

    // First check if we're allowed to retry based on permissions. If we're
    // all good on that front, check to see if the job is eligible for
    // retries.
    if (!this.props.job.permissions.retry.allowed) {
      retryNotAllowedMessage = this.props.job.permissions.retry.message;
    } else if (!this.props.job.retryable.allowed) {
      retryNotAllowedMessage = this.props.job.retryable.message;
    }

    const retryButtonContent = (
      <>
        <Icon
          icon="retry"
          style={{
            width: 14,
            height: 14,
            position: "relative",
            top: -1,
            marginRight: 3,
          }}
        />
        Retry
      </>
    );

    if (retryNotAllowedMessage) {
      // Retries are disabled, let's render a disabled button with a tooltip for more info!
      return (
        <button
          disabled={true}
          className="btn btn-default"
          aria-label={retryNotAllowedMessage}
          style={{ fontSize: 13, height: 34, lineHeight: "13px" }}
        >
          {retryButtonContent}
        </button>
      );
    }

    const options = {
      url: this.props.job.basePath + "/retry",
      method: "post",
      loadingText: "Retrying...",
      className: "btn btn-default",
      style: { fontSize: 13, height: 34, lineHeight: "13px" },
      onSuccess: (event, response) => {
        if (response && response.build) {
          this.props.buildStore.loadAndEmit(response.build);
        }
      },
      onError: (event, response) => {
        if (response && response.message) {
          alert(response.message);
        }
      },
    };

    // Retries are all good! Let's render the button.
    return (
      <RemoteButtonComponent {...options}>
        {retryButtonContent}
      </RemoteButtonComponent>
    );
  },

  renderCancelJobDialog() {
    const options = {
      url: this.props.job.basePath + "/cancel",
      method: "post",
      loadingText: "Canceling...",
      className: "btn btn-danger block center",
      onSuccess: (event, response) => {
        if (response && response.build) {
          this.handleCancelJobDialogClose();
          this.props.buildStore.loadAndEmit(response.build);
        }
      },
      onError: (event, response) => {
        if (response && response.message) {
          alert(response.message);
        }
      },
    };

    return (
      <Dialog
        isOpen={this.state.cancelJobDialogOpen}
        onRequestClose={this.handleCancelJobDialogClose}
        width={400}
      >
        <div className="px4 pb4">
          <h2 className="h2">Are you sure?</h2>
          <p className="mb3">
            Canceling this job may have an impact on the success of the overall
            build. Continue?
          </p>
          <RemoteButtonComponent {...options}>
            Yes, Cancel Job
          </RemoteButtonComponent>
        </div>
      </Dialog>
    );
  },

  renderCancelJobButton() {
    // First check if we're allowed to cancel based on permissions.
    // If not, we'll just bail out early here and return nothing.
    if (!this.props.job.permissions.cancel.allowed) {
      return null;
    }

    const options = {
      className: "btn btn-default",
      style: { fontSize: 13, height: 34, lineHeight: "13px" },
    };

    if (this.props.job.state === "canceling") {
      options.disabled = true;
      options.loading = "Canceling...";
    } else if (!this.props.job.cancelable.allowed) {
      // Don't render the cancel button if it can't be cancelled
      return null;
    }

    return (
      <Button {...options} onClick={this.handleCancelJobClick}>
        <i className="fa fa-times mr1" />
        Cancel
      </Button>
    );
  },

  renderMissingDependencies() {
    if (!this.props.job.missingDependencies.length) {
      return null;
    }

    const isBuildTerminal = TERMINAL_BUILD_STATES.includes(
      this.props.build.state,
    );

    return (
      <div className="pt-4">
        <MissingStepDependencies
          dependencies={this.props.job.missingDependencies}
          variant={isBuildTerminal ? "error" : "warning"}
        />
      </div>
    );
  },

  render() {
    const { className, job } = this.props;

    let state;
    if (TERMINAL_JOB_STATES.includes(job.state)) {
      switch (true) {
        case job.state === "canceled" && job.passed:
          state = "canceled-passed";
          break;
        case job.state === "canceled":
          state = "canceled";
          break;
        case job.passed:
          state = "passed";
          break;
        case job.softFailed:
          state = "soft_failed";
          break;
        default:
          state = "failed";
      }
    } else {
      state = job.state;
    }

    // If we're going to expand and we haven't rendered
    // the job content node before. This small hack lets us lazily
    // load the tabs.
    if (this.state.expanded && !this.lazyLoaded) {
      this.lazyLoaded = true;
    }

    // If it's been lazy loaded, we can start generating the content
    const jobContentNode = this.state.expanded ? (
      <div className="build-details-pipeline-job-body z1">
        {this.renderMissingDependencies()}

        <div className="build-details-pipeline-job-body__controls pt2 mb2 bg-white z2 border-bottom border-gray flex">
          <div className="build-details-pipeline-job-body__actions order-1 flex items-center">
            {this.renderSSHButton()}
            {this.renderTestAnalyticsButton()}
            {this.renderRetryJobButton()}
            {this.renderCancelJobButton()}
          </div>
          <ul
            className="monochrome flex flex-auto items-stretch list-style-none p0 m0 order-0"
            style={{ fontSize: 13, overflowX: "auto", overflowY: "hidden" }}
          >
            {this.tabMenuNodes()}
          </ul>
        </div>
        <div className="tab-content">{this.tabContentNodes()}</div>
      </div>
    ) : null;

    return (
      <>
        <div
          className={classNames(
            `build-details-pipeline-job relative build-details-pipeline-job-state-${state}`,
            { "build-details-pipeline-job-expanded": this.state.expanded },
            className,
          )}
          id={this.elementId()}
          ref={(wrapperNode) => (this.wrapperNode = wrapperNode)}
        >
          <div
            role="button"
            tabIndex="0"
            className="build-details-pipeline-job__header flex items-center antialiased px-3 py-3.5 gap-x-2.5 cursor-pointer color-inherit focus-color-inherit hover-color-inherit focus-bg-silver hover-bg-silver bg-white text-decoration-none z2"
            onClick={this.handleClickHeader}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                this.handleClickHeader(event);
              }
            }}
            aria-pressed={this.state.expanded}
          >
            <div className="flex gap-x-1.5 flex-auto items-center">
              <span className="build-details-pipeline-icon">
                <PipelineStateIcon job={job} />
              </span>
              {this.groupInfoNode()}
              {this.jobNameNode()}
              {this.commandNode()}
            </div>

            {this.specialStateNode() ?? this.missingDependenciesNode()}

            {this.durationsNode()}
            {this.agentNode()}
            {this.clusterQueueNode()}
            {this.signatureNode()}
          </div>
          {jobContentNode}
        </div>
        {this.renderCancelJobDialog()}
      </>
    );
  },

  handleClickNode(event) {
    const selection = window.getSelection();
    const range = document.createRange();

    range.selectNodeContents(event.currentTarget);
    selection.removeAllRanges();
    selection.addRange(range);
  },

  agentNode() {
    if (this.props.job.agentName) {
      return (
        <div className="flex-none xs-hide">
          <Agent
            agentName={this.props.job.agentName}
            agentPath={this.props.job.agentPath}
            queueName={this.props.job.clusterQueue?.key}
            agentsPath={this.props.job.agentsPath}
            onNestedLinkTrigger={this.handleNestedLinkTrigger}
          />
        </div>
      );
    }
  },

  specialStateNode() {
    let text = null;

    if (this.props.job.state === "canceled") {
      text = "Canceled";
    } else if (this.props.job.state === "canceling") {
      text = "Canceling…";
    } else if (this.props.job.state === "timed_out") {
      text = "Timed Out";
    } else if (this.props.job.state === "timing_out") {
      text = "Timing Out…";
    } else if (this.props.job.state === "expired") {
      text = "Expired";
    }

    if (text) {
      return (
        <div className="job-stats flex-none flex items-center gap1 xs-hide">
          <Icon
            icon="heroicons/16/solid/exclamation-triangle"
            className="flex-shrink-0"
            style={{ width: "14px", height: "14px" }}
          />

          <span>{text}</span>
        </div>
      );
    }

    return null;
  },

  missingDependenciesNode() {
    if (!this.props.job.missingDependencies.length) {
      return null;
    }

    const isBuildTerminal = TERMINAL_BUILD_STATES.includes(
      this.props.build.state,
    );

    return (
      <div
        className={classNames("job-stats flex-none xs-hide ", {
          "!text-orange-800 bg-orange-500/[0.18] px-1 rounded":
            !isBuildTerminal,
        })}
      >
        <span>
          {isBuildTerminal
            ? "Step dependencies not found"
            : "Waiting: unresolved step dependencies"}
        </span>
      </div>
    );
  },

  durationsNode() {
    const wait = this.waitNode();
    const duration = this.durationNode();

    let sep;
    if (wait && duration) {
      sep = <span className="xs-hide">·</span>;
    }

    if (wait || duration) {
      return (
        <div className="job-stats job-durations flex nowrap items-center gap-x-1">
          <div className="xs-hide">{wait}</div>
          {sep}
          {duration}
        </div>
      );
    }
  },

  durationNode() {
    if (this.props.job.startedAt) {
      const runTense =
        this.props.job.state === "running" ? "Running for" : "Ran in";

      const duration = jobTime({
        state: this.props.job.state.toUpperCase(),
        startedAt: this.props.job.startedAt,
        finishedAt: this.props.job.finishedAt,
        canceledAt: this.props.job.canceledAt,
        timedOutAt: this.props.job.timedOutAt,
      });

      return (
        <div className="job-stats">
          <span>
            {runTense} <Duration.Short {...duration} />
          </span>
        </div>
      );
    }
  },

  handleNestedLinkTrigger(event) {
    // The job header is a clickable container that expands the job details. We sometimes nest links
    // within this header, and when they're triggered we don't want the expanded state to change, so
    // we'll prevent event propagation here.
    if (
      event.type === "click" ||
      (event.type === "keydown" && event.key === "Enter")
    ) {
      event.stopPropagation();
    }
  },

  clusterQueueNode() {
    if (!this.props.job.agentsPath) {
      return null;
    }

    const queueName = this.props.job.clusterQueue?.key;
    const hasAgent = this.props.job.agentName;

    // Don't render once we have an agent
    if (hasAgent) {
      return null;
    }

    return (
      <div className="flex-none xs-hide">
        <ClusterQueue
          queueName={queueName}
          hasAgent={hasAgent}
          agentsPath={this.props.job.agentsPath}
          onNestedLinkTrigger={this.handleNestedLinkTrigger}
        />
      </div>
    );
  },

  waitNode() {
    if (this.props.job.state === "scheduled") {
      // Only show waiting for scheduled jobs which are runnable
      if (this.props.job.runnableAt) {
        return (
          <WaitTime
            label={
              this.props.build.account.jobMinuteLimitReached
                ? "Waiting for job minutes"
                : "Waiting for agent"
            }
            from={this.props.job.runnableAt}
            to={this.props.job.startedAt}
          />
        );
      }
    } else if (this.props.job.state === "limited") {
      return (
        <WaitTime
          label="Waiting on concurrency group"
          from={this.props.job.runnableAt || this.props.job.createdAt}
          to={this.props.job.startedAt}
        />
      );
    } else if (this.props.job.state === "assigned") {
      return (
        <WaitTime
          label="Waiting to accept"
          from={this.props.job.agentAssignedAt}
        />
      );
    } else if (this.props.job.state === "skipped") {
      // Return a version that doesn't include the timer if it's been skipped
      return (
        <div>
          <span>Skipped</span>
        </div>
      );
    } else if (this.props.job.state === "expired") {
      return (
        <WaitTime
          label="Waited"
          from={this.props.job.runnableAt || this.props.job.createdAt}
          to={this.props.job.expiredAt}
        />
      );
    } else if (
      this.props.job.state === "blocked" ||
      this.props.job.state === "waiting" ||
      this.props.job.state === "waiting_failed"
    ) {
      // Hide on jobs which are blocked or waiting
      return;
    } else if (
      this.props.job.runnableAt &&
      (this.props.job.startedAt || this.props.job.canceledAt)
    ) {
      return (
        <WaitTime
          label="Waited"
          from={this.props.job.runnableAt}
          to={this.props.job.startedAt || this.props.job.canceledAt}
        />
      );
    }
  },
});
